export const FILTER_PRESETS = {
  NONE: null,
  BLACK_AND_WHITE: 'blackAndWhite',
  VINTAGE: 'vintage',
  WARM_GLOW: 'warmGlow',
  COOL_TONE: 'coolTone',
  FADED_FILM: 'fadedFilm',
  SEPIA: 'sepia',
  SOFT_PASTEL: 'softPastel',
  VIBRANT_POP: 'vibrantPop',
  CINEMATIC: 'cinematic',
  NATURAL_ENHANCE: 'naturalEnhance',
  BRIGHT: 'bright',
  CLEAR: 'clear',
};
